<div class="container-card">
  <div class="card">
    <div class="card-head">
      <a [routerLink]="['/productos',producto.art_codtex,producto.art_codnum]">
        <span class="new text-white bg-light-blue" *ngIf="isNew()">NEW</span>
        <span class="mas-vendido text-white bg-green" *ngIf="isMasVendido()">MÁS VENDIDO</span>
        <span class="new-mas-vendido text-white bg-green" *ngIf="isNewMasVendido()">MÁS VENDIDO</span>
        <span class="liquidacion text-white bg-red" *ngIf="isLiquidacion()">LIQUIDACIÓN</span>
        <img [src]="'https://melectricidad.com.ar/images/productosSistemas/'+generarURL()" loading="lazy"
             [alt]="producto.art_descri" width="100%" height="100%">
        <!--                <span class="descuento" *ngIf="producto.oferta.length!=0">{{producto.oferta[0].dto1 + '%'}}</span>-->
      </a>
    </div>
    <div class="card-body">
      <div class="title-conteiner">
        <span class="product-title">
          {{ producto.art_descri }}
        </span>
      </div>
      <div class="precio-conteiner text-center" *ngIf="(logueado||producto.precioVisible=='1')">
        <div class="w-100" *ngIf="producto.oferta.length>0">
          <span class="precio-viejo">${{ producto.precioFinal|number:'1.0-2' }}</span><span
          style="text-decoration: line-through; font-size: 10px; color: #999;"
        >x U. </span> <span class="descuento">{{ producto.oferta[0].dto1 }}
          %</span><span class="text-muted" style="">dto.</span>
        </div>
        <div class="w-100 precio"><b>
          ${{ producto.resultado|number:'1.0-2' }}
        </b>
          <span style="font-size: 10px"
                *ngIf="producto.oferta.length>0">x {{ producto.oferta[0].minimo|number:'1.0-0' }} U.</span>
        </div>
      </div>

      <div class="d-flex flex-row justify-content-center  align-items-center my-4"
           *ngIf="isBotonCompraRedirect(); else noSession">
        <button mat-raised-button class="bg-naranja w-100 text-white" color="primary" matTooltip="Agregar al carrito"
                (click)="agregarCarrito()" *ngIf="(producto.agotado=='0'&&producto.isProximamente=='0')"><i
          class="fas fa-cart-arrow-down"></i> Comprar
        </button>
        <button mat-raised-button class="w-100 text-white btn-agregar-carrito-agotado" color="warn"
                *ngIf="(producto.agotado=='1')">Agotado
        </button>
        <button mat-raised-button class="w-100 text-white" color="warn"
                *ngIf="(producto.isProximamente=='1')">Proximamente
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template #noSession>
  <div class="d-flex flex-row justify-content-center  align-items-center my-4">
    <button mat-raised-button class="bg-naranja w-100 text-white" color="primary" matTooltip="Agregar al carrito"
            [routerLink]="['/inicioSesion']"><i class="fas fa-cart-arrow-down"></i> Comprar
    </button>
  </div>
</ng-template>
